import React from 'react';

export interface AppContextValues {
  defaultController: string;
  defaultParams?: any;
};

const AppContext = React.createContext<AppContextValues>({
  defaultController: '',
  defaultParams: {},
});

export default AppContext;
